import { Link, useLocation, useNavigate } from "react-router-dom";
import image_400 from "assets/common/common/img_400.svg";
import image_401 from "assets/common/common/img_401.svg";
import image_403 from "assets/common/common/img_403.svg";
import image_404 from "assets/common/common/img_404.svg";
import image_405 from "assets/common/common/img_405.svg";
import image_408 from "assets/common/common/img_408.svg";
import image_500 from "assets/common/common/img_500.svg";
import { useEffect } from "react";
import { useQuickAuthStore } from "store/useQuickAuthStore";
import { useMorningAuthStore } from "store/useMorningAuthStore";
import { useAirAuthStore } from "store/useAirAuthStore";
import { useExpressAuthStore } from "store/useExpressAuthStore";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { useMasterAuthStore } from "store/useMasterAuthStore";
import { twMerge } from "tailwind-merge";

const errorStatus = [
    {
        status: 400,
        img: image_400,
        title_message: "잘못된 요청입니다",
        message: `400 Bad Request\n 요청이 올바르지 않습니다.`,
    },
    {
        status: 401,
        img: image_401,
        title_message: "로그인 필요",
        message: `401 Unauthorized\n 로그인 후 이용해 주세요.`,
    },
    {
        status: 403,
        img: image_403,
        title_message: "접근이 제한되었습니다",
        message: `403 Forbidden\n 접근 권한이 없습니다.`,
    },
    {
        status: 404,
        img: image_404,
        title_message: "페이지를 찾을 수 없습니다",
        message: `404 Not Found\n 요청하신 페이지가 존재하지 않거나 삭제되었습니다.`,
    },
    {
        status: 405,
        img: image_405,
        title_message: "허용되지 않은 요청 방식",
        message: `405 Not Method Not Allowed\n 요청 방식이 잘못되었습니다.`,
    },
    {
        status: 408,
        img: image_408,
        title_message: "요청 시간이 초과되었습니다",
        message: `408 Request Timeout\n 응답 시간이 지났습니다.`,
    },
    {
        status: 500,
        img: image_500,
        title_message: "요청 시간이 초과되었습니다",
        message: `500 Internal Server Error\n 잠시 후 다시 시도해 주세요.`,
    },
];
const buttonStyle = `w-full border border-[#FF7B2E] rounded-[8px] text-[#FF7B2E] py-[15px] inline-block`;

export default function ErrorPage({ status, subdomain }: { status?: number; subdomain?: string }) {
    const navigate = useNavigate();
    const location = useLocation();
    const error = errorStatus.find(err => err.status === status);

    useEffect(() => {
        if (error?.status === 401) {
            const quickLogout = useQuickAuthStore.getState().logout;
            const morningLogout = useMorningAuthStore.getState().logout;
            const airLogout = useAirAuthStore.getState().logout;
            const expressLogout = useExpressAuthStore.getState().logout;
            const consoleLogout = useConsoleAuthStore.getState().logout;
            const logoutToGuest = useMasterAuthStore.getState().logoutToGuest;

            switch (subdomain) {
                case "quick":
                    quickLogout();
                    break;
                case "morning":
                    morningLogout();
                    break;
                case "air":
                    airLogout();
                    break;
                case "express":
                    expressLogout();
                    break;
                case "ilshinconsole":
                    consoleLogout();
                    break;
            }

            if (location.pathname.includes("master")) logoutToGuest();

            localStorage.clear();
        }
    }, [error]);

    return (
        <div className="fixed inset-0 z-[100] bg-[#F8F8F8] min-h-[100dvh] flex justify-center items-center">
            <span className="absolute top-0 left-0 text-[1px] text-transparent">{subdomain}..</span>
            {error && (
                <div className="text-center w-full max-w-[480px] px-10">
                    <h2 className="text-[#1B1C1E] text-[36px] font-bold break-keep">{error.title_message}</h2>
                    <img src={error.img} alt="" />
                    <p className="break-keep">{error.message}</p>
                    {error.status === 401 ? (
                        <Link to="/login" state={{ error: true }} className={twMerge(buttonStyle, "mt-10")}>
                            로그인 페이지로 이동
                        </Link>
                    ) : (
                        <div className="w-full flex flex-col gap-2 mt-10">
                            <Link to="/" state={{ error: true }} className={buttonStyle}>
                                홈페이지로 이동 하기
                            </Link>
                            <button
                                onClick={() => {
                                    navigate(-1);
                                }}
                                className={buttonStyle}
                            >
                                이전 페이지로 돌아가기
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
